

import React, { useState, useEffect } from 'react';
import { obtenerRenovacionPorIdCarrito } from '../redux/aRenovaciones';
import { useSelector } from 'react-redux';
import ErrorPage from '../../../components/ErrorPage';
import { MENSAJES_ESTADOS } from '../constants/enums';

function ContainerRenovaciones({ children, idCarrito, estadosPermitidos = [] }) {

    const datosUsuario = useSelector(state => state.datosUsuarios.dataUsuario);

    const [renovacion, setRenovacion] = useState(null);

    function estadoPermitido() {
        if (!renovacion || !renovacion.estado) return false;
        return estadosPermitidos.includes(renovacion.estado);
    }

    useEffect(() => {
        async function fetchCarrito() {
            const result = await obtenerRenovacionPorIdCarrito(idCarrito, `${datosUsuario.brokerCodigo}&cliCodigoCore=${datosUsuario.cliCodigoCore}`);
            setRenovacion(result);
            console.log("Renovación obtenida:", result);

        }
        fetchCarrito();
    }, [idCarrito]);

    return (
        <div className="container-renovaciones">
            {
                <React.Fragment>
                    {children}
                </React.Fragment>
            }
        </div>
    );
}

export default ContainerRenovaciones;